<template>
    <v-card class="pa-10" height="514" width="540">
      <v-card-text>
          <div class="d-flex">
            <h3 class="mr-2 pb-1">{{propertyUnit.name}}</h3> <i>Available {{ formatDate(availableDate) }}</i>
          </div>
          <p class="mb-6">{{line}}</p>

        <div>
          <v-img :src="propertyUnit.floor_plan_image_url || require('@/assets/icons/icon-apt.svg')"></v-img>
        </div>
      </v-card-text>
    </v-card>
</template>

<script>
    import moment from "moment";
    export default {
        name: 'PropertyFloorPlanImage',
        props: {
          propertyUnit: {
            type: Object,
            required: true
          },
          availableDate: {
            type: String
          }
        },
      computed: {
          bedLine() {
            return this.propertyUnit.number_of_bedrooms > 1
                ? `${this.propertyUnit.number_of_bedrooms} beds`
                : `${this.propertyUnit.number_of_bedrooms} bed`
          },
          bathLine() {
            return `${this.propertyUnit.number_of_baths} ba`
          },
          sqFootLine() {
            return `${this.propertyUnit.square_feet} sq ft`
          },
          priceLine() {
            return `$${this.propertyUnit.price}`
          },
          line() {
            return `${this.bedLine} | ${this.bathLine} | ${this.sqFootLine} | ${this.priceLine}`
          }
      },
      methods: {
        formatDate(date) {
          return moment(date).format('MMMM D')
        }
      }
    }
</script>